import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_PARTNER_LISTING_HOUSEHOLDS_STARTED_APPLYING,
} from 'api/actionTypes';

export default async function getHouseholdsStartedApplyingToListing(
  { state, apiClient },
  {
    listingId,
    forceRefresh = false,
  }
) {
  typeCheck('listingId::PositiveNumber', listingId);

  const currentPartnerStatePath = ['partners', 'householdsStartedApplyingByListingId', String(listingId)];
  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_LISTING_HOUSEHOLDS_STARTED_APPLYING,
    queryId: listingId,
    state: state,
    payload: {
      listingId,
    },
    onSuccess(householdsApplying) {
      if (householdsApplying) {
        state.set(currentPartnerStatePath, householdsApplying);
      }
    },
  });
}
